'use strict';

var stripAnsi = require('strip-ansi');
var isFullwidthCodePoint = require('is-fullwidth-code-point');
var emojiRegex = require('emoji-regex')();
module.exports = function (input) {
  input = input.replace(emojiRegex, '  ');
  if (typeof input !== 'string' || input.length === 0) {
    return 0;
  }
  input = stripAnsi(input);
  var width = 0;
  for (var i = 0; i < input.length; i++) {
    var code = input.codePointAt(i);

    // Ignore control characters
    if (code <= 0x1F || code >= 0x7F && code <= 0x9F) {
      continue;
    }

    // Ignore combining characters
    if (code >= 0x300 && code <= 0x36F) {
      continue;
    }

    // Surrogates
    if (code > 0xFFFF) {
      i++;
    }
    width += isFullwidthCodePoint(code) ? 2 : 1;
  }
  return width;
};